import { render, staticRenderFns } from "./EforcementInformation.vue?vue&type=template&id=b89e6bc2&scoped=true&"
import script from "./EforcementInformation.vue?vue&type=script&lang=js&"
export * from "./EforcementInformation.vue?vue&type=script&lang=js&"
import style0 from "./EforcementInformation.vue?vue&type=style&index=0&id=b89e6bc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89e6bc2",
  null
  
)

export default component.exports